import styled from 'styled-components'

export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`

interface StyledAvatarProps {
  $label?: boolean
}

export const StyledAvatar = styled.div<StyledAvatarProps>`
  margin: 0 ${({ $label }) => ($label ? 10 : 0)}px;
`
